// A potência cilíndrica é sempre negativa por convenção — alguns registos
// vêm gravados sem o "-" (ex: "0.75"). Isto é só visual: nunca altera o
// valor guardado/enviado, só o texto mostrado ao cliente.
//
// Aceita também array (ex: ["0.75"]) porque é assim que o Chakra Select
// devolve o valor selecionado nas lentes de contacto (guardado tal e qual
// no product_options do carrinho/encomenda).
export function formatCylindricalPower(
  value: string | string[] | null | undefined,
): string {
  const raw = Array.isArray(value) ? value[0] : value;
  if (!raw) return '';

  const trimmed = raw.trim();
  if (trimmed.startsWith('-')) return trimmed;
  const stripped = trimmed.startsWith('+') ? trimmed.slice(1) : trimmed;
  return `-${stripped}`;
}
